import { AllocationMonitoringDashboard } from './AllocationMonitoringDashboard';

export default function OperationalDashboardPage() {
  return <AllocationMonitoringDashboard variant="operational" />;
}
